import { Ability, AbilityBuilder } from '@casl/ability';

export function defineAbilitiesFor(user) {
  const { can, build } = new AbilityBuilder(Ability);

  if (user.permissions && Array.isArray(user.permissions)) {
    user.permissions.forEach(permission => {
      can(permission.action, permission.model);
    });
  }

  const role = user.role 
  if (role && Array.isArray(role.permissions)) {
    role.permissions.forEach((permission) => {
      if (permission?.action && permission?.model) {
        can(permission.action, permission.model);
      }
    });
  }

   // Safety net for ADMIN role
  if (role?.type === 'ADMIN' || role?.type === 'Manager') {
    can('manage', 'all');
  }
  
  return build();
}
